// extracted by mini-css-extract-plugin
export var standaloneTable = "_i9-0";
export var standaloneTableWithBodyFill = "_i9-1";
export var withExtraHeader = "_i9-2";